module.exports = __webpack_public_path__ + "static/media/image4.8c21ec80.jpeg";